import { MutationCache, QueryCache, QueryClient } from 'react-query';
import * as Sentry from '@sentry/react';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  },
  // Filtering and tagging of ApiRequestError failures happens centrally in sentry.ts's
  // beforeSend, so every capture path (react-query, or a manual Sentry.captureException
  // elsewhere) is treated consistently.
  queryCache: new QueryCache({
    onError: (error) => {
      Sentry.captureException(error);
    }
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      Sentry.captureException(error);
    }
  })
});

export const queryKeys = {
  area: 'area',
  user: 'user',
  brreg: 'brreg',
  building: 'building',
  buildingList: 'buildingList',
  energyAnalysis: 'energyAnalysis',
  energyAnalysisList: 'energyAnalysisList',
  energyplanMeasures: 'energyplanMeasures',
  expertReports: 'exportReports',
  kommune: 'kommune',
  userSelectedBuildingList: 'userSelectedBuildingList',
  search: 'search',
  searchPoststed: 'searchPoststed',
  searchBuilding: 'searchBuilding',
  advancedSearch: 'advancedSearch',
  portfolio: 'portfolio',
  portfolioList: 'portfolioList',
  portfolioMeasures: 'portfolioMeasures',
  insulation: 'insulation',
  statistic: 'statistic',
  unofficialEnergyCertificate: 'unofficialEnergyCertificate',
  userInput: 'userInput',
  applicationMeasures: 'applicationMeasures',
  supportLevels: 'supportLevels',
  measureCategories: 'measureCategories',
  flerboligRegistration: 'flerboligRegistration',
  userExpertRegistrations: 'userExpertRegistrations',
  grupperegistreringMeasures: 'grupperegistreringMeasures',
  measures: 'measures',
  systemAlert: 'systemAlert',
  // Is only used to check if submitRegistration request is pending inside adjustParameters.
  // Used to disable ActionButtons in registration wizard. Will be removed.

  UNSAFE_SumitRegistrationAsQuery: 'hack-query-key'
};
